// ============================================
// 全局工具函数
// ============================================

// 检查是否为RTL语言
function isRTL() {
  var pathname = window.location.pathname;
  return pathname.includes('/ar') || pathname.includes('/he') || pathname.includes('/ur');
}

// 防抖函数
function debounce(func, wait) {
  var timeout;
  return function executedFunction() {
    var context = this;
    var args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// 节流函数
function throttle(func, limit) {
  var inThrottle;
  return function() {
    var args = arguments;
    var context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(function() {
        inThrottle = false;
      }, limit);
    }
  };
}

// 通用Slick箭头配置
var slickPrevArrow = '<button class="slick-prev slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>';
var slickNextArrow = '<button class="slick-next slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>';

// 初始化Slick轮播（带销毁检查）
function initSlick($el, settings) {
  if (!$el || $el.length === 0) return;
  if ($el.hasClass('slick-initialized')) {
    $el.slick('unslick');
  }
  // 自动添加RTL支持
  settings.rtl = isRTL();
  $el.slick(settings);
}

// 显示消息
function showMessage(message, isError) {
  var msgClass = isError ? 'error-message' : 'success-message';
  var $existing = $('.' + msgClass);
  if ($existing.length === 0) {
    $('body').append('<div class="' + msgClass + '" style="position:fixed; bottom:20px; left:50%; transform:translateX(-50%); background:' + (isError ? '#e55a2b' : '#28a745') + '; color:white; padding:12px 24px; border-radius:8px; z-index:9999; display:none; font-size:14px;"></div>');
    $existing = $('.' + msgClass);
  }
  $existing.text(message).fadeIn(300).delay(3000).fadeOut(300);
}

// ============================================
// 修复：不要移动 WebPixelsManagerSandboxContainer
// ============================================
// 原代码错误 - 已移除，保留在原始位置即可
// var contentDiv = $('#WebPixelsManagerSandboxContainer');
// $('footer').after(contentDiv);

// ============================================
// 文档就绪初始化
// ============================================

$(document).ready(function() {

  // 移动菜单到footer后面
  jQuery('.mobile-menu-wrapper').insertAfter('.site-footer');

  // address page - 移除_method hidden field
  $('.edit-spacer input[type="hidden"][name="_method"][value="put"]').remove();

  // 初始化倒计时
  if (typeof countDownIni === 'function') {
    countDownIni('.flip-countdown,.js-flip-countdown');
  }

  // ========== 滚动粘性header（带节流优化） ==========
  $(window).scroll(throttle(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
      $("header").addClass("head-sticky");
    } else {
      $("header").removeClass("head-sticky");
    }
  }, 100));

  // ========== 购物车弹窗 ==========
  if ($('body').hasClass('cart')) {
    $('.cart-header').on('click', function(event) {
      event.preventDefault();
      return false;
    });
  } else {
    $('.cart-header').off('click').on('click', function(e) {
      e.preventDefault();
      setTimeout(function() {
        $('body').addClass('no-scroll cartOpen');
        $('.overlay').addClass('cart_overlay');
      }, 50);
    });
  }

  // 关闭购物车弹窗
  $('body').on('click', '.overlay.cart_overlay, .closecart', function(e) {
    e.preventDefault();
    $('.overlay').removeClass('cart_overlay');
    $('body').removeClass('no-scroll cartOpen');
    $('.coupon-popup').removeClass('active');
    $('.gift-popup').removeClass('active');
  });

  // ========== 优惠券弹窗（修复拼写：coupan-icon → coupon-icon） ==========
  $(document).on('click', '.coupon-icon', function() {
    $(".coupon-popup").toggleClass("active");
  });
  $(document).on('click', '.gift-icon', function() {
    $(".coupon-popup").removeClass("active");
  });
  $(document).on('click', '.close-coupon', function() {
    $(".coupon-popup").removeClass("active");
  });

  // ========== 优惠码输入（优化：防抖 + 手动应用） ==========
  var discountDebounce;
  $('body').on('keyup', '.discount-coupon', function() {
    var $input = $(this);
    clearTimeout(discountDebounce);
    discountDebounce = setTimeout(function() {
      var applyHref = $('.apply').attr("href");
      if (applyHref) {
        var baseUrl = applyHref.split('discount=')[0];
        var val = $input.val();
        var newHref = baseUrl + 'discount=' + encodeURIComponent(val);
        $('.apply').attr("href", newHref);
        // 移除自动触发点击，改为手动
      }
    }, 500);
  });

  // 手动应用优惠码
  $('body').on('click', '.apply-coupon, .apply', function(e) {
    e.preventDefault();
    var $applyBtn = $('.apply');
    var href = $applyBtn.attr('href');
    if (href && href.includes('discount=')) {
      window.location.href = href;
    } else {
      showMessage('Please enter a discount code', true);
    }
  });

  // ========== 礼物弹窗 ==========
  $(document).on('click', '.gift-icon', function() {
    $(".gift-popup").toggleClass("active");
  });
  $(document).on('click', '.coupon-icon', function() {
    $(".gift-popup").removeClass("active");
  });
  $(document).on('click', '.close-gift', function() {
    $(".gift-popup").removeClass("active");
  });

  // ========== 移动菜单 ==========
  $('.mobile-menu-button').on('click', function(e) {
    e.preventDefault();
    setTimeout(function() {
      $('body').addClass('no-scroll active-menu');
      $(".mobile-menu-wrapper").toggleClass("active-menu");
      $('.overlay').addClass('menu-overlay');
    }, 50);
  });

  $('body').on('click', '.overlay.menu-overlay, .menu-close-icon svg', function(e) {
    e.preventDefault();
    $('body').removeClass('no-scroll active-menu');
    $(".mobile-menu-wrapper").removeClass("active-menu");
    $('.overlay').removeClass('menu-overlay');
  });

  // ========== 移动筛选弹窗 ==========
  $('.mobile-facets__open').on('click', function(e) {
    $('body').addClass('mobile-open no-scroll');
    $('.overlay').addClass('active');
  });
  $('.overlay,.close-filter,.apply-btn').on('click', function(e) {
    $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
    $('.overlay').removeClass('active');
  });

  // ========== Cookie ==========
  $('.cookie-close').click(function() {
    $('.cookie').slideUp();
  });

  // ========== 订阅弹窗 ==========
  if ($('.subscribe-popup').length > 0) {
    $('body').addClass('no-scroll');
  }
  $('.close-sub-btn').click(function() {
    $('.subscribe-popup').slideUp();
    $(".subscribe-overlay").removeClass("open");
    $('body').removeClass('no-scroll');
  });

  // ========== 尺码弹窗 ==========
  $(".size-btn").click(function() {
    $(".size-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  $(".close-search, .close-btn").click(function() {
    $(".size-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });

  // ========== 多级导航菜单 ==========
  $('.acnav-label').click(function() {
    var $label = $(this);
    var $parent = $label.parent('.has-children');
    var $list = $label.siblings('.acnav-list');
    if ($parent.hasClass('is-open')) {
      $list.slideUp('fast');
      $parent.removeClass('is-open');
    } else {
      $list.slideDown('fast');
      $parent.addClass('is-open');
    }
  });

  // ========== 首页轮播 ==========
  initSlick($('.thumb-slider-main'), {
    autoplay: false,
    slidesToShow: 1,
    speed: 1000,
    slidesToScroll: 1,
    prevArrow: slickPrevArrow,
    nextArrow: slickNextArrow,
    dots: false,
    arrows: true,
    asNavFor: '.home-right-slider'
  });

  initSlick($('.home-right-slider'), {
    autoplay: false,
    slidesToShow: 1,
    speed: 1000,
    slidesToScroll: 1,
    prevArrow: slickPrevArrow,
    nextArrow: slickNextArrow,
    dots: false,
    arrows: false,
    asNavFor: '.thumb-slider-main'
  });

  // ========== 国家/城市滑块 ==========
  if ($('.countries-visit-slider').length > 0) {
    initSlick($('.countries-visit-slider'), {
      autoplay: false,
      slidesToShow: 3,
      speed: 1000,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: 0,
      prevArrow: slickPrevArrow,
      nextArrow: slickNextArrow,
      dots: false,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 501, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // ========== 博客滑块 ==========
  if ($('.blog-slider').length > 0) {
    initSlick($('.blog-slider'), {
      autoplay: true,
      slidesToShow: 2,
      speed: 1000,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: 0,
      prevArrow: slickPrevArrow,
      nextArrow: slickNextArrow,
      dots: false,
      responsive: [
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // ========== 最佳产品滑块 ==========
  if ($('.bestpro-slider').length > 0) {
    initSlick($('.bestpro-slider'), {
      autoplay: false,
      slidesToShow: 3,
      speed: 1000,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: 0,
      prevArrow: slickPrevArrow,
      nextArrow: slickNextArrow,
      dots: false,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // ========== 酒店滑块 ==========
  if ($('.hotel-slider').length > 0) {
    initSlick($('.hotel-slider'), {
      autoplay: false,
      slidesToShow: 3,
      speed: 1000,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: 0,
      prevArrow: slickPrevArrow,
      nextArrow: slickNextArrow,
      dots: false,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // ========== 文章滑块 ==========
  if ($('.article-slider').length > 0) {
    initSlick($('.article-slider'), {
      autoplay: false,
      slidesToShow: 3,
      speed: 1000,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: 0,
      prevArrow: slickPrevArrow,
      nextArrow: slickNextArrow,
      dots: false,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // ========== 精选分类滑块 ==========
  if ($('.featured-cat-slider').length > 0) {
    initSlick($('.featured-cat-slider'), {
      autoplay: false,
      slidesToShow: 4,
      speed: 1000,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: slickPrevArrow,
      nextArrow: slickNextArrow,
      dots: false,
      responsive: [
        { breakpoint: 1400, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 450, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // ========== 货币切换 ==========
  $('body').on('click', '.currency .nice-select', function(e) {
    e.stopPropagation();
    $(this).toggleClass('open');
  });
  $('body').on('click', function() {
    $('.currency .nice-select').removeClass('open');
  });

  if (document.querySelectorAll('.currency .nice-select .list li').length > 0) {
    document.querySelectorAll('.currency .nice-select .list li').forEach(function(currencyItem) {
      currencyItem.addEventListener('click', function() {
        var selectElement = this.closest('.currency').querySelector('select');
        if (selectElement) {
          selectElement.value = this.dataset.currency;
          var event = new Event('change', { bubbles: true });
          selectElement.dispatchEvent(event);
          selectElement.form.submit();
        }
      });
    });
  }

  // ========== 缺货提醒弹窗 ==========
  $('body').on('click', '.notify-btn', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll notify-active');
    $('.out-of-stock-form,.overlay').addClass('active');
  });
  $('body').on('click', '.overlay,.notify-popup-close', function(e) {
    e.preventDefault();
    $('body').removeClass('no-scroll notify-active');
    $('.out-of-stock-form,.overlay').removeClass('active');
  });

  // ========== 粘性添加到购物车按钮 ==========
  if ($('body').hasClass('product')) {
    $.fn.isInViewport = function() {
      var elementTop = this.offset().top;
      var elementBottom = elementTop + this.outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    $(window).scroll(throttle(function() {
      if ($('.cart-btn.product-button').isInViewport()) {
        $('.products-add-cart-sticky').removeClass('show-btn');
      } else {
        $('.products-add-cart-sticky').addClass('show-btn');
      }
    }, 100));
  }

  // ========== 粘性选项选择器 ==========
  $(".stickyOpt.nice-select").on('click', function() {
    $(this).toggleClass('open');
  });

  $(".stickyOpt .vrOpt").on('click', function(e) {
    var sectionId = $('.product-main-section .container').attr('data-section-id');
    var number = $(this).data('no');
    $(".stickyOpt .selectedOpt").html($(this).html());
    $(this).toggleClass('open');
    this.productvariants = JSON.parse(document.getElementById('variants' + sectionId).innerHTML);
    var stOpt = this.productvariants[number],
      o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
    $('.stickCtImg').attr('src', stOpt.featured_image.src + '&width=100');
    if (!$('select.single-option-selector').length) {
      if (o2 != null) {
        var stOpt2 = o2.replace(/'/g, "\\'");
        $(".swatchInput[value='" + stOpt2 + "']").prop("checked", true);
      }
      if (o3 != null) {
        var stOpt3 = o3.replace(/'/g, "\\'");
        $(".swatchInput[value='" + stOpt3 + "']").prop("checked", true);
      }
      if (o1 != null) {
        var stOpt1 = o1.replace(/'/g, "\\'");
        $(".swatchInput[value='" + stOpt1 + "']").trigger('click');
      }
    }
  });

  $(".stickyQty .quantity__button").on("click", function() {
    var qtyField = $('.mianQty'),
      oldValue = $(qtyField).val(),
      newVal = 1;
    if ($(this).is(".quantity-increment")) {
      newVal = parseInt(oldValue) + 1;
    } else if (oldValue > 1) {
      newVal = parseInt(oldValue) - 1;
    }
    $(qtyField).val(newVal).trigger('change');
  });
  $('.mianQty').on("change", function() {
    $('#stquantity').val($(this).val());
  });

  // ========== 快速查看弹窗 ==========
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });

  $('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href = '/products/' + $(this).find('a').data('handle') + '?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      initSlick($('.qv_slider'), {
        autoplay: false,
        slidesToShow: 1,
        speed: 1000,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        dots: false,
        infinite: false
      });
    });
    $('.quickview-popup').show();
  });

  $('body').on('change', '.quickview_popup_data .colors-box .button', function() {
    var data_val = $(this).children('input:checked').val();
    $(this).parents('.colors').find('.option-label').text(data_val);

    var selectedValues = [];
    $('.quickview_popup_data .colors-box .button input:checked').each(function() {
      var selectedValue = $(this).val();
      if (selectedValue) {
        selectedValues.push(selectedValue);
      }
    });
    var joinedValues = selectedValues.join(' / ');

    $('.variant-qv').each(function() {
      var variant_title = $(this).data('title');
      var variant_img = $('.variant-qv[data-title="' + variant_title + '"]').data('img');
      var variant_price = $('.variant-qv[data-title="' + variant_title + '"]').data('price');
      var qv_btn = $('.variant-qv[data-title="' + variant_title + '"]').data('avail');
      var variant_id = $('.variant-qv[data-title="' + variant_title + '"]').data('id');
      variant_title = String(variant_title);
      joinedValues = String(joinedValues);

      if (variant_title === joinedValues) {
        var slideIndex = $('.qv_slider .qv-pro-slider-img img[data-img="' + variant_img + '"]').parent().index();
        $('.qv_slider').slick('slickGoTo', slideIndex);
        $('.qv-price').find('.price-item--regular').text(variant_price);
        if (qv_btn === true) {
          $('#quick-view-temp .product-form__submit').find('span').text('Add to Cart');
          $('#quick-view-temp .product-form__submit').removeAttr('disabled');
        } else {
          $('#quick-view-temp .product-form__submit').find('span').text('Sold out');
          $('#quick-view-temp .product-form__submit').attr('disabled', 'disabled');
        }
        $('input[name="id"]').val(variant_id);
      }
    });
  });

  // ========== 产品详情页轮播 ==========
  initSlick($('.pdp-main-slider'), {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    arrows: false,
    asNavFor: '.pdp-thumb-slider'
  });

  initSlick($('.pdp-thumb-slider'), {
    arrows: true,
    prevArrow: slickPrevArrow,
    nextArrow: slickNextArrow,
    dots: false,
    asNavFor: '.pdp-main-slider',
    speed: 1000,
    slidesToScroll: 1,
    touchMove: true,
    focusOnSelect: true,
    infinite: true,
    slidesToShow: 4,
    responsive: [{
      breakpoint: 1261,
      settings: { slidesToShow: 3 }
    }]
  });

  // ========== 灯箱 ==========
  if ($('.lightbox').length > 0) {
    $('.lightbox').slickLightbox({
      itemSelector: 'a.open-lightbox',
      caption: 'caption',
      prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
      nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
      navigateByKeyboard: true,
      layouts: {
        closeButton: '<button class="close"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M27.7618 25.0008L49.4275 3.33503C50.1903 2.57224 50.1903 1.33552 49.4275 0.572826C48.6647 -0.189868 47.428 -0.189965 46.6653 0.572826L24.9995 22.2386L3.33381 0.572826C2.57102 -0.189965 1.3343 -0.189965 0.571605 0.572826C-0.191089 1.33562 -0.191186 2.57233 0.571605 3.33503L22.2373 25.0007L0.571605 46.6665C-0.191186 47.4293 -0.191186 48.666 0.571605 49.4287C0.952952 49.81 1.45285 50.0007 1.95275 50.0007C2.45266 50.0007 2.95246 49.81 3.3339 49.4287L24.9995 27.763L46.6652 49.4287C47.0465 49.81 47.5464 50.0007 48.0463 50.0007C48.5462 50.0007 49.046 49.81 49.4275 49.4287C50.1903 48.6659 50.1903 47.4292 49.4275 46.6665L27.7618 25.0008Z" fill="white"></path></svg></button>'
      }
    });

    $(".pdp-main-media").click(function() {
      if ($('a.pdp-main-media').hasClass('open-lightbox')) {
        $('body').addClass('no-scroll');
      } else {
        $('body').removeClass('no-scroll');
      }
    });
    $('body').on('click', '.slick-lightbox-inner .close, .slick-lightbox-hide', function() {
      $('body').removeClass('no-scroll');
    });
  }

  // ========== 产品图片缩放 ==========
  if (typeof $.fn.zoom === 'function') {
    $('.pdp-main-media.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover',
        touch: true,
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });
  }

});

// ============================================
// 窗口加载完成后的初始化
// ============================================

$(window).on('load resize orientationchange', debounce(function() {
  var headerHeight = $('header').outerHeight();
  $('header').next('.wrapper').css('margin-top', headerHeight + 'px');
}, 150));

// ============================================
// 账户页面导航滚动
// ============================================

if ($(".my-acc-column").length > 0) {
  jQuery(function($) {
    var topMenuHeight = $("#daccount-nav").outerHeight();
    $("#account-nav").menuScroll(topMenuHeight);
    $(".account-list li:first-child").addClass("active");
  });

  jQuery.fn.extend({
    menuScroll: function(offset) {
      var topMenu = this;
      var topOffset = offset ? offset : 0;
      var menuItems = $(topMenu).find("a");
      var lastId;
      var scrollItems = $(menuItems).map(function() {
        var item = $($(this).attr("href"));
        if (item.length) return item;
      });

      $(topMenu).on("click", "a", function(e) {
        var href = $(this).attr("href");
        var offsetTop = href === "#" ? 0 : $(href).offset().top - topOffset;
        var windowWidth = $(window).width();
        var extraOffset = windowWidth <= 767 ? 200 : 100;
        $('html, body').stop().animate({ scrollTop: offsetTop - extraOffset }, 300);
        e.preventDefault();
      });

      $(window).scroll(throttle(function() {
        var nm = $("html").scrollTop();
        var nw = $("body").scrollTop();
        var fromTop = (nm > nw ? nm : nw) + topOffset;
        var windowWidth = $(window).width();
        var offsetAdjust = windowWidth <= 767 ? 250 : 0;

        var current = $(scrollItems).map(function() {
          if ($(this).offset().top - offsetAdjust <= fromTop) return this;
        });
        current = current[current.length - 1];
        var id = current && current.length ? current[0].id : "";
        if (lastId !== id) {
          lastId = id;
          $(menuItems).parent().removeClass("active").end()
            .filter("[href='#" + id + "']").parent().addClass("active");
        }
      }, 100));
    }
  });
}

// ============================================
// 表单向导（Steppy Form）- 修复阻止提交问题
// ============================================

var totalSteps = $(".steps li").length;

// 修复：移除错误的 return false，改为正常的表单验证
// $(".submit").on("click", function(){ return false; }); // 已删除

$(".steps li:nth-of-type(1)").addClass("active");
$(".myContainer .step-container:nth-of-type(1)").addClass("active");

$(".step-container").on("click", ".next", function() {
  $(".steps li").eq($(this).parents(".step-container").index() + 1).addClass("active");
  $(this).parents(".step-container").removeClass("active").next().addClass("active");
  $(this).closest('.form-wizard').find('.slick-slider').slick('refresh');
});

$(".step-container").on("click", ".back", function() {
  $(".steps li").eq($(this).parents(".step-container").index() - totalSteps).removeClass("active");
  $(this).parents(".step-container").removeClass("active").prev().addClass("active");
  $(this).closest('.form-wizard').find('.slick-slider').slick('refresh');
});

// ============================================
// 响应式菜单
// ============================================

function responsiveMenu() {
  if (jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row');
  } else {
    $('.product-filter-column').prependTo('.product-list-row');
    if ($('body').hasClass('mobile-open')) {
      $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    }
  }

  if (jQuery(window).width() < 992) {
    if (!$('.mobile-lag').length) {
      var newDiv = document.createElement('ul');
      newDiv.className = 'mobile-lag d-flex aling-item-center';
      $(newDiv).insertAfter('.menu-close-icon');
      $('.languages, .currency').prependTo('.mobile-lag');
    }
  } else {
    $('.languages, .currency').insertBefore('.cart-header');
    $('.mobile-lag').remove();
  }
}

jQuery(document).ready(function() {
  responsiveMenu();
});
jQuery(window).resize(debounce(responsiveMenu, 150));

// ============================================
// 倒计时函数
// ============================================

function countDownIni(countdown) {
  if (typeof $().countdown !== 'function') return;
  $(countdown).each(function() {
    var $countdown = $(this);
    var promoperiod;
    if ($countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt($countdown.attr('data-promoperiod'), 10);
    } else if ($countdown.attr('data-countdown')) {
      promoperiod = $countdown.attr('data-countdown');
    }
    if (promoperiod && Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      $countdown.countdown(promoperiod, function(event) {
        $countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' +
          '<span><span>%H</span><span class="dots"> : </span></span>' +
          '<span><span>%M</span><span class="dots"> : </span></span>' +
          '<span><span class="second">%S</span></span>'));
      });
    } else if (promoperiod && Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
      $(this).parent().css('display', 'none');
    }
  });
}